// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closeButton--wPwke {
  color: inherit;
  opacity: 0.4;
  position: absolute;
  top: 20px;
  transition: 0.1s ease-in-out;
  fill: currentcolor;
  display: inline-block;
  font: inherit;
  line-height: 0;
  overflow: visible;
  text-transform: none;
}[dir] .closeButton--wPwke {
  transition-property: color, opacity;
  background-color: transparent;
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 0;
}[dir=ltr] .closeButton--wPwke {
  right: 15px;
}[dir=rtl] .closeButton--wPwke {
  left: 15px;
}

.title--rwPrX h3 {
  color: #333;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Roboto,
    Helvetica Neue,
    Arial,
    Noto Sans,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;
  font-weight: 400;
  text-transform: none;
  font-size: 1.5rem;
  line-height: 1.4;
}

[dir] .title--rwPrX h3 {
  margin: 0 0 20px;
  margin-bottom: 0.5rem;
  margin-top: 0;
}

[dir] .description--jCJwY p {
  margin: 0 0 20px;
}

[dir] .description--jCJwY a {
  background-color: #e6512d;
  border-color: #f59201;
}

[dir=ltr] .description--jCJwY a {
  margin-left: 20px;
}

[dir=rtl] .description--jCJwY a {
  margin-right: 20px;
}

.idpSitewideNotice--HNWRN {
  position: fixed;
  bottom: 0;
  transition: all 1s linear;
  z-index: 50;
}

[dir] .idpSitewideNotice--HNWRN {
  background: rgba(255, 255, 255, 0.95);
  border-top: #e6512d 2px solid;
}

[dir=ltr] .idpSitewideNotice--HNWRN {
  left: 0;
  right: 0;
  padding: 20px 20px 30px 90px;
}

[dir=rtl] .idpSitewideNotice--HNWRN {
  right: 0;
  left: 0;
  padding: 20px 90px 30px 20px;
}

[dir] .idpSitewideNotice--HNWRN:hover {
  background: rgba(255, 255, 255, 1);
}

.idpSitewideNoticeIcon--ob4YI {
  position: absolute;
  top: 50%;
}

[dir] .idpSitewideNoticeIcon--ob4YI {
  margin-top: -25px;
}

[dir=ltr] .idpSitewideNoticeIcon--ob4YI {
  left: 20px;
}

[dir=rtl] .idpSitewideNoticeIcon--ob4YI {
  right: 20px;
}

.idpSitewideNoticeIcon--ob4YI svg {
  width: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SiteWideNotice/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAElB,SAAS;EACT,4BAA4B;EAE5B,kBAAkB;EAIlB,qBAAqB;EACrB,aAAa;EACb,cAAc;EAEd,iBAAiB;EAEjB,oBAAoB;AACtB,CAnBA;EAOE,mCAAmC;EAEnC,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAIhB,SAAS;EAET,UAAU;AAEZ,CAnBA;EAIE,WAAW;AAeb,CAnBA;EAIE,UAAW;AAeb;;AAEA;EACE,WAAW;EACX;;;;;;;;;;;;oBAYkB;EAClB,gBAAgB;EAEhB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAGlB;;AAtBA;EAgBE,gBAAgB;EAIhB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AAEvB;;AAJA;EAGE,iBAAiB;AACnB;;AAJA;EAGE,kBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EAMT,yBAAyB;EACzB,WAAW;AACb;;AAVA;EAKE,qCAAqC;EAErC,6BAA6B;AAG/B;;AAVA;EAGE,OAAO;EACP,QAAQ;EAER,4BAA4B;AAI9B;;AAVA;EAGE,QAAO;EACP,OAAQ;EAER,4BAA4B;AAI9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EAGE,kBAAkB;EAClB,QAAQ;AACV;;AALA;EAEE,iBAAiB;AAGnB;;AALA;EACE,UAAU;AAIZ;;AALA;EACE,WAAU;AAIZ;;AAEA;EACE,WAAW;AACb","sourcesContent":[".closeButton {\n  color: inherit;\n  opacity: 0.4;\n  position: absolute;\n  right: 15px;\n  top: 20px;\n  transition: 0.1s ease-in-out;\n  transition-property: color, opacity;\n  fill: currentcolor;\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  display: inline-block;\n  font: inherit;\n  line-height: 0;\n  margin: 0;\n  overflow: visible;\n  padding: 0;\n  text-transform: none;\n}\n\n.title h3 {\n  color: #333;\n  font-family:\n    -apple-system,\n    BlinkMacSystemFont,\n    Segoe UI,\n    Roboto,\n    Helvetica Neue,\n    Arial,\n    Noto Sans,\n    sans-serif,\n    Apple Color Emoji,\n    Segoe UI Emoji,\n    Segoe UI Symbol,\n    Noto Color Emoji;\n  font-weight: 400;\n  margin: 0 0 20px;\n  text-transform: none;\n  font-size: 1.5rem;\n  line-height: 1.4;\n  margin-bottom: 0.5rem;\n  margin-top: 0;\n}\n\n.description p {\n  margin: 0 0 20px;\n}\n\n.description a {\n  background-color: #e6512d;\n  border-color: #f59201;\n  margin-left: 20px;\n}\n\n.idpSitewideNotice {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 20px 20px 30px 90px;\n  border-top: #e6512d 2px solid;\n  transition: all 1s linear;\n  z-index: 50;\n}\n\n.idpSitewideNotice:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n.idpSitewideNoticeIcon {\n  left: 20px;\n  margin-top: -25px;\n  position: absolute;\n  top: 50%;\n}\n\n.idpSitewideNoticeIcon svg {\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": `closeButton--wPwke`,
	"title": `title--rwPrX`,
	"description": `description--jCJwY`,
	"idpSitewideNotice": `idpSitewideNotice--HNWRN`,
	"idpSitewideNoticeIcon": `idpSitewideNoticeIcon--ob4YI`
};
export default ___CSS_LOADER_EXPORT___;
